/**
 * Get the translated value for a product field based on the current language.
 * Falls back to the default field value if translation is missing.
 *
 * @param {Object} product - The product object
 * @param {string} field - The field to get (e.g., 'name', 'description')
 * @param {string} language - The current language code (e.g., 'en', 'fr')
 * @returns {string} - The translated or default string
 */
export const getTranslatedProduct = (product, field, language) => {
  if (!product) return '';

  const translations = product.translations;
  if (translations && translations[field]) {
    // 1. Try exact match (e.g. 'fr-FR' or 'fr')
    if (translations[field][language]) {
      return translations[field][language];
    }
    // 2. Try short code if language has region (e.g. 'fr-FR' -> 'fr')
    if (language.includes('-')) {
      const shortLang = language.split('-')[0];
      if (translations[field][shortLang]) {
        return translations[field][shortLang];
      }
    }
  }

  // Fallback to the default root-level field (usually English)
  return product[field] || '';
};
